import React, {useRef, useState, useEffect} from "react";
import styles from "./InfoItem.module.css";
import classNames from "classnames"
import {useDispatch, useSelector} from "react-redux";
import {Button, Checkbox, Col, message, Row, Switch} from 'antd'
import {setRechargeUserInfo} from "./teacherManagerSlice";
import {setCurrentMenuKey} from "../HomePageSlice";

export default function InfoItem(props) {
    const dispatch = useDispatch();
    const [confirmInfo, setConfirmInfo] = useState({})
    const [messageApi, contextHolder] = message.useMessage();


    return <tr
        className={styles.tr1}
    >
        <td
            className={styles.td1}
        >{props.item.name}
        </td>
        <td
            className={styles.td1}
        >{props.item.user_login}
        </td>
        <td
            className={styles.td1}
        >
            {props.item.jifen}
            {/* {parseInt(props.item.jifen)+parseInt(props.item.chongzhi_jifen)} */}
        </td>
        <td
            className={styles.td1}
        >
            {props.item.chongzhi_jifen}
        </td>
        {/*<td*/}
        {/*    className={styles.td1}*/}
        {/*>{props.item.teacher_num}*/}
        {/*</td>*/}
        {/*<td*/}
        <td
            className={styles.td1}
        >
            <Switch
                checked={props.item.status==1}
                onChange={(checked) => {
                    console.log(checked);
                    props.changeStatus(props.item,checked);
                }}
                checkedChildren="开"
                unCheckedChildren="关"
                // style={{ backgroundColor: user.status=='1' ? '#52c41a' : '#bfbfbf' }}
                style={{marginLeft: 10, marginRight: 10}}
            />

        </td>
        <td
            className={styles.td1}
        >{props.item.ctime}
        </td>
        <td
            className={styles.td2}
            style={{minWidth:220}}
        >
            <div style={{display:"flex",justifyContent:"center"}}>
                <Row>
                    <Col span={6}>
                        <Button
                            color="primary"
                            variant="link"
                            onClick={() => {
                                props.editMethod(props.item);
                            }}
                        >
                            编辑
                        </Button>
                    </Col>
                    <Col span={11}>
                        <Button
                            color="primary"
                            variant="link"
                            onClick={(e)=>{
                                console.log(props.item);
                                dispatch(setRechargeUserInfo(props.item));
                                dispatch(setCurrentMenuKey("61"))
                            }}
                        >
                            积分分配
                        </Button>
                    </Col>
                    <Col span={7}>
                        <Button
                            color="primary"
                            variant="link"
                            onClick={(e)=>{
                                props.deleteMethod(props.item);
                            }}
                        >
                            删除
                        </Button>
                    </Col>
                </Row>
            </div>

        </td>

        {contextHolder}
    </tr>
}
// export default PaymentInfoList;


